<template>
  <div>
    <slot name="activate" :open-dialog="openDialog" />

    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <img :src="src" width="100%" alt="" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  methods: {
    openDialog() {
      this.dialog = true
    },
  },
}
</script>

<style lang="scss" scoped></style>
